import { Post } from 'lib/types';
import { POST_TYPES } from 'lib/constants';
import { abbreviateNum } from 'lib/helpers';

export function getTop(post: Post) {
  if (post.type === POST_TYPES.VIDEO && post.currentCombinedViews > post.currentLikes) {
    return {
      type: 'VIEWS',
      count: abbreviateNum(post.currentCombinedViews, 0),
      text: 'Views',
    };
  }

  return {
    type: 'LIKES',
    count: abbreviateNum(post.currentLikes, 0),
    text: 'Likes',
  };
}
